import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel} from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';

/** MyMine Version2.0 AHSLv2SubLv2画面新規追加
* AHSLv2SubLv2 Page Content
*/
export const AHSLv2SubLv2 = () => {
  const screenId = 'MyM315';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const [isLoading, setIsLoading] = useState(true);
  

  useEffect(() => {
    const endLoading = () => setIsLoading(false);

    apiRequest.requestJson('api/ahs/lv2-2', 'GET', endLoading, endLoading);
  }
    , [])

  if (isLoading)
    return <MyMProgress />

  return (
    <Grid container className='mt-4'>
      <Grid item xs={1} />
      <Grid item xs={10} >
        <Box sx={{ padding: '5px', marginBottom: '30px' }}>
          <MyMLabel >{controlSettings.LabelList.lblNecessityOfAhsAssessmentDescription}</MyMLabel>
        </Box>
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '50px' 
        }}>
          <MyMImage
            screenId={screenId}
            filePath={controlSettings.ImageList.imgNecessityOfAhsAssessmentDescription1}
            alt='NecessityOfAhsAssessmentDescription1'
            height='auto'
            width='80%'
            display='block'
          />
        </Box>
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: '100px' 
        }}>
        <MyMImage
          screenId={screenId}
          filePath={controlSettings.ImageList.imgNecessityOfAhsAssessmentDescription2}
          alt='NecessityOfAhsAssessmentDescription2'
          height='auto'
          width='65%'
          display='block'
          />
          <Grid item xs={10} md={12} lg={5.5}>
            <Box  sx={{ paddingLeft:'35px' }} >
              <MyMLabel fontSize='19px' sx={{ paddingBottom: '30px', fontWeight: 'bold', color:'#00bFFF'}}>{controlSettings.LabelList.lblNecessityOfAhsAssessmentDescriptionText1}</MyMLabel>
              <MyMLabel fontSize='19px' sx={{ paddingBottom: '30px' }}>{controlSettings.LabelList.lblNecessityOfAhsAssessmentDescriptionText2}</MyMLabel>
              <MyMLabel fontSize='19px' sx={{ paddingBottom: '0px' }}>{controlSettings.LabelList.lblNecessityOfAhsAssessmentDescriptionText3}</MyMLabel>
            </Box>
          </Grid>
        </Box>
      </Grid >
      <Grid item xs={1} />
    </Grid >

  );
}

export default AHSLv2SubLv2;